import { render, staticRenderFns } from "./StatisticsOrders.vue?vue&type=template&id=36f8dbca&scoped=true"
import script from "./StatisticsOrders.vue?vue&type=script&lang=js"
export * from "./StatisticsOrders.vue?vue&type=script&lang=js"
import style0 from "./StatisticsOrders.vue?vue&type=style&index=0&id=36f8dbca&prod&lang=css"
import style1 from "./StatisticsOrders.vue?vue&type=style&index=1&id=36f8dbca&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f8dbca",
  null
  
)

export default component.exports